import { render } from "./Browser.vue?vue&type=template&id=2ffcca63&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"

import "./Browser.vue?vue&type=style&index=0&id=2ffcca63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffcca63"]])

export default __exports__